export default "__VITE_ASSET__CudVIdb8__";